
	import {
		Component,
		Vue,
		Inject
	} from 'vue-property-decorator';
	import Footer from '../components/Footer.vue'
	// import TenantSwitch from '../components/tenant-switch.vue'
	//import LanguageSwitch from '../components/language-switch.vue'
	import iView from 'iview';
	import AbpBase from '../lib/abpbase'
	@Component({
		components: {
			Footer,
			// TenantSwitch,
			//LanguageSwitch
		}
	})
	export default class ForgetPassword extends AbpBase {
		model: any = {
			username: '',
			email: '',
			password: '',
			rePassword: '',
			code: '',
			codeTime: 60,
			type: '',
			modalParam: {}
		}
		isTest: boolean = false;
		isFocus: boolean = false;
		disabled: boolean = true;
		localizationList : Array<any> = [];
		state : string = "";
		token : string = "";
		chekPwd:string="";
		btnDisabled: boolean = false;
		
		
		activateaccount:Object={
			en: "Activate Account",
			chs: "激活账户"
		}
		mobile:Object={
			en: "Mobile",
			chs: "手机号"
		}
		code:Object={
			en: "Code",
			chs: "验证码"
		}
		send:Object={
			en: "Send",
			chs: "发送"
		}
		newpassword:Object={
			en: "New Password",
			chs: "新密码"
		}
		confirmpassword:Object={
			en: "Confirm Password",
			chs: "确认新密码"
		}
		submit:Object={
			en: "Submit",
			chs: "确定"
		}
		role:Object={			
			en: "Password security policy:",
			chs: "密码安全策略："
		}
		role1:Object={
			en: "1. The password cannot contain user / account information;",	
			chs: "1.密码不能包含用户/账号名信息；"	
		}
		role2:Object={
			en: "2. The password must be at least 8 characters long and must contain uppercase letters, lowercase letters and numbers. It is recommended to add special characters;",
			chs: "2.密码长度至少为8位，必须包含大小写字母+数字，建议增加特殊字符；"		
		}
		
		sendtips:Object={
			en:"sending...",
			chs:"发送中..."
		}			
		EnterPhone:Object={
			en:"Please enter your phone number",
			chs:"请输入手机号"
		}
		OK:Object={
			en:"OK",
			chs:"确定"
		}
		Tips:Object={
			en:"Tips",
			chs:"提示"
		}
		CodeNotEmpty:Object={
			en:"The verification code cannot be empty",
			chs:"验证码不能为空"
		}
		EnterPassword:Object={
			en:"Please enter your password",
			chs:"请输入密码"
		}
		PasswordDifferent:Object={
			en:"The passwords are different",
			chs:"两次密码不一致"
		}
		UpdateSuccess:Object={
			en:"Success",
			chs:"更新成功"
		}
		changeLang: Object = {
			en: "Language",
			chs: "语言"
		};
		
		lang: string = "zh-Hans";
		changLang() {
			if (this.lang == "en") {
				this.lang = 'zh-Hans';
				abp.utils.setCookieValue(
					"Abp.Localization.CultureName",
					'zh-Hans',
					new Date(new Date().getTime() + 5 * 365 * 86400000), //5 year
					abp.appPath
				);
			} else {
				this.lang = 'en';
				abp.utils.setCookieValue(
					"Abp.Localization.CultureName",
					'en',
					new Date(new Date().getTime() + 5 * 365 * 86400000), //5 year
					abp.appPath
				);
			}
		
			if (abp.utils.getCookieValue("Abp.Localization.CultureName") == "en") {
				this.lang = 'en';
			} else {
				this.lang = 'zh-Hans';
			}
			this.model.modalParam.confirmText = this.L(this.OK);
			this.model.modalParam.title = this.L(this.Tips);
			this.loadLocalization();
			
		}
		
		formattedText(rawText) {
			// 替换换行符为<br>
			let textWithNewLines = rawText.replace(/\n/g, '<br>');
			// 替换多个空格为一个空格
			let textWithoutMultipleSpaces = textWithNewLines.replace(/\s+/g, ' ');
			return textWithoutMultipleSpaces;
		}
		
		L(name) {
		
			var n = '';
		
		
			if (name == this.changeLang ||
				name == this.activateaccount ||
				name == this.mobile ||				
				name == this.code ||
				name == this.send ||
				name == this.newpassword ||
				name == this.confirmpassword ||
				name == this.submit ||
				name == this.role ||
				name == this.role1 ||
				name == this.role2 ||
				name == this.sendtips ||
				name == this.EnterPhone ||
				name == this.OK ||
				name == this.Tips ||
				name == this.CodeNotEmpty ||
				name == this.EnterPassword ||
				name == this.PasswordDifferent ||
				name == this.UpdateSuccess) {
				if (this.lang == 'en') {
					n = name.en
				} else {
					n = name.chs
				}
			} else {
				var that = this;
				var findindex = that.localizationList.findIndex(e => {
					return e.name == name
				})
				if (findindex > -1) {
					n = that.localizationList[findindex].value
				} else {
					n = name;
				}
		
			
			}
		
			return n;
		
		}
			
			
		mounted() {
			let self = this
			document.onkeydown = function(e) {
				let ev = (document.all ? window.event : e) as any
				if (ev.keyCode === 13) {
					self.sure()
				}
			}
		}		
		created() {			
			if(abp.utils.getCookieValue("Abp.Localization.CultureName")=="en")
			{
				this.lang='en';
			}
			else
			{
				this.lang='zh-Hans';
			}
			
			this.isTest = this.$route.query.istest as any == "1";
			this.model.modalParam.confirmText = this.L(this.OK);
			this.model.modalParam.title = this.L(this.Tips);
			// if (!this.model.modalParam.confirmText || this.model.modalParam.confirmText == '') {
			// 	this.model.modalParam.confirmText = "确定 OK";
			// }
			// if (!this.model.modalParam.title || this.model.modalParam.title == '') {
			// 	this.model.modalParam.title = "提示 Tips";
			// }
			this.loadLocalization();
		

		}
		
		loadLocalization() {
			var that = this;
		
			this.$store.dispatch({
				type: 'app/getLocalizations',
				data: this.lang
			}).then((res) => {
				that.localizationList = res;
			});
		
		}
		lanValue(name) {
			var that = this;
			var findindex = that.localizationList.findIndex(e => {
				return e.name == name
			})
			if (findindex > -1) {
				return that.localizationList[findindex].value
			} else {
				return '';
			}
		
		}
		
		async sendCode() {
			var that = this;

			if (this.model.username.length == 0) {
				this.$Modal.warning({
					content: this.L(this.EnterPhone),
					title: that.model.modalParam.title,
					okText: that.model.modalParam.confirmText,
				})
				return;
			}
			//var phoneReg = /^1[1-9]\d{9}$/;
			var phoneReg = /^[0-9]\d*$/　;
			var emailReg = /^([a-zA-Z]|[0-9])(\w|\-)+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})$/;
			if (phoneReg.test(that.model.username)) {
				this.$Message.loading({
					content: this.L(this.sendtips),
					duration: 0
				})

				that.model.type = 'phone';
				this.$store.dispatch({
					type: 'app/sendPhoneCode',
					data: {
						username: that.model.username,
						istest:that.isTest,
						lang:that.lang
					}
				}).then((res) => {
					that.$Message.destroy();
					//that.isFocus=true;
					//(that.$refs.tempFocus as any).focus();					
					if (res.status == 200 && res.data.success) {
						var result = res.data.result;
						if (result.errorNumber == 0) {
							that.disabled = false;
							this.$nextTick(() => {
								(that.$refs.tempFocus as any).focus()
							})
							that.model.codeTime = 60;
							that.sendtime(that.model.codeTime);
						} else {
							that.$Modal.warning({
								content: result.errors[0],
								title: that.model.modalParam.title,
								okText: that.model.modalParam.confirmText,
							})

							return;
						}


					}
				})
				setTimeout(function() {
					that.$Message.destroy();
				}, 5000)
			} else if (emailReg.test(that.model.username)) {
				this.$Message.loading({
					content: this.L(this.sendtips),
					duration: 0
				})
				that.model.type = 'email';
				this.$store.dispatch({
					type: 'app/sendEmailCode',
					data: {
						username: that.model.username,
						istest:that.isTest
					}
				}).then((res) => {
					//that.isFocus=true;
					//(that.$refs.tempFocus as any).focus();
					that.$Message.destroy();
					if (res.status == 200 && res.data.success) {

						var result = res.data.result;
						if (result.errorNumber == 0) {
							that.disabled = false;
							this.$nextTick(() => {
								(that.$refs.tempFocus as any).focus()
							})
							that.model.codeTime = 60;
							that.sendtime(that.model.codeTime);
						} else {
							this.$Modal.warning({
								content: result.errors[0],
								title: that.model.modalParam.title,
								okText: that.model.modalParam.confirmText,
							})

							return;
						}
					}
				})
				setTimeout(function() {
					that.$Message.destroy();
				}, 5000)
			} else {
				that.model.username = that.model.username + '@yfpo.com';
				that.sendCode();
			}
		}
		sendtime(wait) {
			var that = this;
			if (wait == 0) {
				that.model.codeTime = 60;
			} else {
				that.model.codeTime = wait;
				wait--;
				setTimeout(function() {
					that.sendtime(wait)
				}, 1000)
			}
		}
		sure() {
			var that = this;
			if (this.model.username.length == 0) {
				that.$Modal.warning({
					content: this.L(this.EnterPhone),
					title: that.model.modalParam.title,
					okText: that.model.modalParam.confirmText,
				})
				return;
			}
			
			if (this.model.password.length == 0) {
				that.$Modal.warning({
					content: this.L(this.EnterPassword),
					title: that.model.modalParam.title,
					okText: that.model.modalParam.confirmText,
				})
				return;
			}
			if (this.model.password != this.model.rePassword) {
				that.$Modal.warning({
					content: this.L(this.PasswordDifferent),
					title: that.model.modalParam.title,
					okText: that.model.modalParam.confirmText,
				})
				return;
			}
			if (this.model.code.length == 0) {
				that.$Modal.warning({
					content: this.L(this.CodeNotEmpty),
					title: that.model.modalParam.title,
					okText: that.model.modalParam.confirmText,
				})
				return;
			}
			if (that.state != '' && that.token != '') {
				that.updatePwd(that.state, that.token);
			}
			else{
				if (that.model.type == "phone") {
					this.$store.dispatch({
						type: 'app/confirmPhoneCode',
						data: {
							username: that.model.username,
							code: that.model.code,
							istest:that.isTest
						}
				
					}).then((res) => {
						if (res.status == 200 && res.data.success) {
							var result = res.data.result;
							if (result.errorNumber == 0) {
								that.state = result.state;
								that.token = result.accessToken
								that.updatePwd(result.state, result.accessToken);
							} else {
								that.$Modal.warning({
									content: result.errors[0],
									title: that.model.modalParam.title,
									okText: that.model.modalParam.confirmText,
								})
								return;
							}
				
						}
					})
				
				} else if (that.model.type == "email") {
					this.$store.dispatch({
						type: 'app/confirmEmailCode',
						data: {
							username: that.model.username,
							code: that.model.code,
							istest:that.isTest
						}
					}).then((res) => {
						if (res.status == 200 && res.data.success) {
							var result = res.data.result;
							if (result.errorNumber == 0) {
								that.state = result.state;
								that.token = result.accessToken
								that.updatePwd(result.state, result.accessToken);
							} else {
								that.$Modal.warning({
									content: result.errors[0],
									title: that.model.modalParam.title,
									okText: that.model.modalParam.confirmText,
								})
								return;
							}
				
						}
					})
				}
			}
			
		}
		updatePwd(state, accessToken) {
			var that = this;
			that.btnDisabled = true;
			this.$store.dispatch({
				type: 'app/updatePassword',
				data: {
					userName: that.model.username,
					newPassword: that.model.password,
					reNewPassword: that.model.rePassword,
					state: that.state,
					accessToken: that.token,
					istest:that.isTest
				}
			}).then((obj) => {
				that.btnDisabled = false;
				if (obj.status == 200 && obj.data.success) {
					var resultObj = obj.data.result;

					var success = that.L(that.UpdateSuccess);
					// if (!success || success == '') {
					// 	success = "修改成功 , update successfully!";
					// }
					if (resultObj.errorNumber == 0) {
						that.$Modal.success({
							content: success,
							title: that.model.modalParam.title,
							onOk: () => {
								if (that.isTest) {
									location.href = "#/downloadafter?istest=1"
								} else {
									location.href = "#/downloadafter"
								}

							}
						})
					} else {
						that.$Modal.warning({
							content: resultObj.errors[0],
							title: that.model.modalParam.title,
							okText: that.model.modalParam.confirmText,
						})
						return;
					}
				}
			})

		}
		checkPwd() {
			var that = this;
			//console.log('chekPwd:'+that.chekPwd+',newPassword:'+that.model.password)
			if(that.model.username!='' && that.model.password!='' && that.chekPwd!=that.model.password){
				that.chekPwd=JSON.parse(JSON.stringify(that.model.password));
				this.$store.dispatch({
					type: 'app/checkPassword',
					data: {
						userName: that.model.username,
						newPassword: that.model.password,
					}
				}).then((obj) => {
					if (obj.status == 200 && obj.data.success) {
						var resultObj = obj.data.result;
						
						var success = that.L(that.UpdateSuccess);
						
						// var success = that.L('UpdateSuccess');
						// if (!success || success == '') {
						// 	success = "修改成功 , update successfully!";
						// }
						if (resultObj.errorNumber != 0) {
							that.$Modal.warning({
								content: that.L(resultObj.errors[0]),
								title: that.model.modalParam.title,
								okText: that.model.modalParam.confirmText,
							})
							return;
						} 
					} else {
						that.$Modal.warning({
							content: that.L(obj.data.error.message),
							title: that.model.modalParam.title,
							okText: that.model.modalParam.confirmText,
						})
						return;
					}
				})
						
			}
			
		}
	}
